// Official archived rules for the 7th Annual Dalleo Open.
export const RULES_PUBLISHED = true;
export const RULES_APPROVED = true;

export const RULES = {
  header: {
    title: "Official Rules — 2026 Dalleo Open",
    edition: "7th Annual Dalleo Open · 2026",
    description: "The official rules and format used for the completed 2026 tournament.",
  },
  draftNotice: "",
  quickReminders: [
    "No mulligans, gimmes, or breakfast balls",
    "Confirm every score before submission",
    "Use one club length for approved drops",
    "When in doubt, consult the group before proceeding",
  ],
  sectionNav: [
    { id: "format", label: "Tournament Format" },
    { id: "match-rules", label: "Official Rules" },
    { id: "conduct", label: "Conduct" },
    { id: "tiebreakers", label: "2026 Result" },
    { id: "faq", label: "FAQ" },
  ],
  format: {
    intro:
      "The 2026 Dalleo Open was played as an 8-team, four-person scramble championship. All four players hit each shot, the team selected the best ball, and everyone played from that spot. The tournament used a shotgun start and one 18-hole round. Lowest team score won.",
    points: [
      "8 teams, four players per team — captained and drafted",
      "Four-person scramble: all four players hit each shot",
      "The team selects the best ball, and everyone plays from that spot",
      "All teams played from the black tee boxes",
      "Shotgun start — one round on Saturday, September 5, 2026",
      "Lowest team score wins the championship",
    ],
    note: "The 2026 tournament is complete. Team Martin won with a 69 (−3), two strokes ahead of Team Breaud.",
  },
  matchRules: [
    { id: "tee-boxes", title: "Tee Boxes", body: "All teams played from the black tee boxes — par 72, 7,092 yards (course rating 74.3, slope 135)." },
    { id: "no-free-shots", title: "No Mulligans, Gimmes, or Breakfast Balls", body: "There were no mulligans, no conceded putts, and no breakfast balls. Every counted stroke was played." },
    { id: "ob-drop", title: "Out of Bounds", body: "For an out-of-bounds ball, take the approved drop within one club length. The drop could not be moved into the fairway." },
    { id: "retee", title: "Re-Tee Rule", body: "If both applicable tee shots were bad, a re-tee was allowed with the next shot played as stroke two under the tournament rule." },
    { id: "unplayable", title: "Unplayable Lies", body: "If a ball was considered unplayable, the group was required to consult together before deciding how to proceed." },
    { id: "bush", title: "Bush / No Clean Hit", body: "If the selected ball finished in a bush or another position with no clean hit, the team could attempt the shot or take the approved drop." },
    { id: "hole-13", title: "Hole 13 — Dalleo Tradition", body: "The mandatory Dalleo shotgun rule applied on Hole 13." },
    { id: "score-reporting", title: "Score Reporting", body: "Teams confirmed scores within the group before the captain submitted them to the live scoring system." },
    { id: "disputes", title: "Disputes & Rulings", body: "Any unclear situation was handled with the group first. Tournament organizers had final authority on rulings." },
  ],
  conduct: [
    { title: "Sportsmanship", body: "Compete hard, play fairly, and protect the friendly spirit of the Dalleo Open." },
    { title: "Respect", body: "Treat fellow players, course staff, and everyone involved with the event with respect." },
    { title: "Safe Play", body: "Stay aware of nearby groups and look out for one another on the course." },
    { title: "Pace of Play", body: "Keep pace with the group ahead and be ready when it is your turn." },
    { title: "Honest Scoring", body: "Report scores accurately. The integrity of the leaderboard depends on it." },
    { title: "The Spirit of the Event", body: "The tournament exists to honor Dalleo through friendship, competition, and the tradition the group has built together." },
  ],
  tiebreakers: {
    note: "No tie-breaker was required in 2026. Team Martin finished at 69 (−3), two strokes ahead of Team Breaud at 71 (−1).",
    steps: [
      "Champion: Team Martin — 69 (−3)",
      "Runner-up: Team Breaud — 71 (−1)",
      "Final margin: 2 strokes",
    ],
  },
  faq: [
    { id: "faq-format", title: "What format was used in 2026?", body: "Eight teams of four played one 18-hole four-person scramble with a shotgun start." },
    { id: "faq-tees", title: "Which tees were used?", body: "The field played the black tees at LA Tour: par 72, 7,092 yards, rating 74.3 and slope 135." },
    { id: "faq-scores", title: "Where are the final scores?", body: "The completed standings and scorecards are preserved on the Leaderboard page." },
    { id: "faq-winner", title: "Who won the 2026 Dalleo Open?", body: "Team Martin won with a 69 (−3), finishing two strokes ahead of Team Breaud." },
  ],
  unpublished: {
    title: "Rules unavailable",
    body: "The official 2026 rules archive is temporarily unavailable.",
  },
};
